




































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { getCookie, delCookie, setCookie } from "@/JS/cookie"; //使用getCookie方法
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import Bus from "@/JS/Bus";
import httpApi from "@/API/Tenant/Weixin";
import list from "./list.vue"; //表单列表
import add from "./add.vue"; //海报编辑
import viewlist from "./viewlist.vue"; //查看列表
import statistical from "./statistical.vue"; //查看统计数据
import posterSeting from "./posterSeting.vue";
@Component({
  components: { list, add, viewlist, statistical, posterSeting }
})
export default class extends Vue {
  @Provide() activeName: string = "listForm"; //当前选中tab的name
  @Provide() WxQrCodePosterList: any = {};
  @Provide() WxQrCodePosterDetail: any = {};
  @Provide() page: any = {};
  async created() {}
  async addModifyForm(formData: any) {
    //console.log(formData);
    this.activeName = formData.pagename;
    this.WxQrCodePosterList = formData.WxQrCodePosterList;
    this.WxQrCodePosterDetail = formData.WxQrCodePosterDetail;
    //console.log(this.activeName);
    this.seche();
  }
  async seche() {
    var _this = this;
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.WxQrCodePosterList
        }
      ]
    };
    var res = await httpApi.GetVerifyData(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      let data = res.output[0].value;
      // console.log(data);
      Bus.$emit("posterInfo", data);
      // console.log(_this.posterInfo);

      //  getCookie("PosterId");
      // this.PosterId = data.PosterId;
      // let expireDays = 1000 * 60 * 60;
      // setCookie("PosterId", data.PosterId, expireDays);
      // setCookie("TenantID", data.TenantId, expireDays);
      // setCookie("WxQrCode", data.WxQrCode, expireDays);
      // setCookie("Aid", data.Aid, expireDays);
    } else {
      //this.$message.error("加载修改数据失败：" + res.ErrorMessage);
    }
  }
}
